import { render } from "./UserLogin.vue?vue&type=template&id=5035bcf6&scoped=true"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"

import "./UserLogin.vue?vue&type=style&index=0&id=5035bcf6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5035bcf6"]])

export default __exports__